import { render } from "./index.vue?vue&type=template&id=5c9ea0ae"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__